import { Box } from '@chakra-ui/react';

import { Progress } from './progress';

export const Fallback: React.FC = () => (
  <Box as='section' minH='100vh'>
    <Progress />
  </Box>
);
